import { combineReducers } from "redux";
import toDos from "./toDos.js";
import userIdentity from "./userIdentity.js";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import storageSession from 'redux-persist/lib/storage/session'

const persistConfig = {
  key: "root",
  storage,
  whiteList: ["toDos", "userIdentity"],
};

const rootReducer = combineReducers({
  toDos: toDos,
  userIdentity: userIdentity,
});

export default persistReducer(persistConfig, rootReducer);
